module.exports = __webpack_public_path__ + "static/img/food-kyf.c22c4a9.svg";


//////////////////
// WEBPACK FOOTER
// ./static/food-kyf.svg
// module id = 3f4N
// module chunks = 1